import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  learnMoreUrl?: string;
  children?: React.ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left';
  ariaLabel?: string;
}

const Tooltip: React.FC<TooltipProps> = ({
  content,
  learnMoreUrl,
  children,
  position = 'top',
  ariaLabel = 'Information',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const positionClasses = {
    top: 'bottom-full mb-2 left-1/2 -translate-x-1/2',
    right: 'left-full ml-2 top-1/2 -translate-y-1/2',
    bottom: 'top-full mt-2 left-1/2 -translate-x-1/2',
    left: 'right-full mr-2 top-1/2 -translate-y-1/2',
  };

  return (
    <div className="relative inline-flex">
      <div
        onMouseEnter={() => setIsOpen(true)}
        onMouseLeave={() => setIsOpen(false)}
        onClick={() => setIsOpen(!isOpen)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsOpen(!isOpen);
          }
        }}
      >
        {children ? (
          children
        ) : (
          <button
            type="button"
            className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-slate-700 hover:bg-slate-600 text-gray-300 hover:text-white transition-colors"
            aria-label={ariaLabel}
          >
            <span className="text-xs font-bold">ℹ</span>
          </button>
        )}
      </div>

      {isOpen && (
        <div
          className={`absolute z-50 ${positionClasses[position]} w-64 p-3 bg-slate-800 border border-slate-600 rounded-lg shadow-lg text-sm text-gray-200`}
          role="tooltip"
          aria-hidden={!isOpen}
        >
          <p>{content}</p>
          {learnMoreUrl && (
            <a
              href={learnMoreUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-2 text-blue-400 hover:text-blue-300 underline text-xs"
            >
              Learn more →
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
